import { render, staticRenderFns } from "./DomainResult.vue?vue&type=template&id=62f0bdf5&"
import script from "./DomainResult.vue?vue&type=script&lang=js&"
export * from "./DomainResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports